import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
  },
  mutations: {
    setUser(state, user) {
        const newState = { ...state }; // Cria uma cópia do objeto state
        newState.user = user; // Atribui o valor à propriedade user da cópia
        if (user) {
          axios.defaults.headers.common.Authorization = `bearer ${user.token}`;
        } else {
          delete axios.defaults.headers.common.Authorization;
        }
        Object.assign(state, newState); // Atualiza o state com a cópia modificada
    },
  },
  actions: {
    initializeUser({ commit }) {
      // Verificar se existem dados de usuário armazenados
      const user = localStorage.getItem('__cogumelos_umami_user');
      if(user) {
        // Atualizar o state do Vuex com os dados armazenados
        commit('setUser', JSON.parse(user));
      }
    }
  },
  getters: {
    getUser: state => state.user
  },
});
